/**
 * Created by jmmartinez
 * v.1.1  13/01/2025 Si onCancelar == null no se renderiza el boton de Cancelar
 * v.1.2  14/01/2025 Añadida propiedad mostrarCancelar y su uso para mostrar o no el botón "Cancelar"
 *
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Button, Dialog, FormGroup, InputGroup, Intent, Spinner, Tooltip} from "@blueprintjs/core";
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";



class DialogoEsqueleto extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            opened: props.opened,
        }

    }


    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if(nextProps.opened !== prevState.opened){
            newState.opened= nextProps.opened;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onCancelar= () => {
        const{onCancelar} = this.props;
        this.setState({ opened: false}, () =>{
            onCancelar && onCancelar();
        });
    }

    onAceptar= () => {
        const{onAceptar} = this.props;
        this.setState({ opened: false}, () => {
            onAceptar && onAceptar();
        });
    }


    render() {
        const {opened} = this.state;
        const {titulo, icon, width, height, children, onCancelar, mostrarCancelar} = this.props;
        let heightReal= height ? height : 100;

        //let mostrarCancelarReal= !mostrarCancelar || Boolean(mostrarCancelar);
        //console.log("RENDER DIALOGOESQUELETO: opened:", opened );
        return (
            <>
                <Dialog
                    icon={icon}
                    onClose={this.onCancelar}
                    title= {titulo}
                    isOpen={opened}
                    usePortal= {true}
                    canOutsideClickClose={false}
                    style={{width: width ? width : "50%"}}
                    //style={{ width: "50%"}}
                    //autofocus={true}
                    onOpened={this.fijarFocoInicial}
                >
                    <div className={Classes.DIALOG_BODY} style={{height: heightReal}}>
                        <div>
                            {children}
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Aceptar">
                                <Button intent={Intent.SUCCESS} icon="tick-circle"
                                        onClick={this.onAceptar}>Aceptar</Button>
                            </Tooltip>
                            { (mostrarCancelar == undefined || Boolean(mostrarCancelar)) &&
                            <Tooltip content="Cancelar">
                                <Button intent={Intent.DANGER} icon="delete" onClick={this.onCancelar}>Cancelar</Button>
                            </Tooltip>
                            }
                        </div>
                    </div>
                </Dialog>
            </>
        )
    }


}


DialogoEsqueleto.propTypes = {
    opened: PropTypes.bool,
    titulo: PropTypes.string,
    icon: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
    mostrarCancelar: PropTypes.bool,
}


export default DialogoEsqueleto;



